"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var PageHeader = /** @class */ (function (_super) {
    __extends(PageHeader, _super);
    function PageHeader() {
        var _this = _super.call(this, constants_1.DATA_HEADER) || this;
        if (!_this.getElement()) {
            return _this;
        }
        _this.header = _this.getElement();
        _this.mainNav = _this.getChildElement("[".concat(constants_1.DATA_MAIN_NAV, "]"));
        _this.mainNavToggle = _this.getChildElements("[".concat(constants_1.DATA_MAIN_NAV_TOGGLE, "]"));
        _this.maskFirstElement = document.querySelector('.section');
        _this.scrollHideHeader(_this.header);
        _this.scrollChangeColor(_this.header);
        _this.changeColorOfHeader();
        _this.addMarginToFirstContentElement();
        _this.resetHeader();
        return _this;
    }
    /**
     * Add class 'is-scrolled' to page-header if page is scrolled and removing class if user scrolling up
     * @param header - page-header,
     * @private
     */
    PageHeader.prototype.scrollHideHeader = function (header) {
        var lastScrollTop = 0;
        var isScrolling;
        window.addEventListener('scroll', function () {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var headerHeight = header.clientHeight;
            window.clearTimeout(isScrolling);
            isScrolling = setTimeout(function () {
                if ((scrollTop > lastScrollTop) && !header.classList.contains('is-open')) {
                    if (scrollTop > (headerHeight + 40)) {
                        if (header.classList.contains('scrolled-up')) {
                            header.classList.remove('scrolled-up');
                            header.classList.add('is-scrolled-start');
                            header.classList.remove('stay-top');
                            setTimeout(function () {
                                header.classList.add('is-scrolled');
                            }, 300);
                        }
                        else if (!header.classList.contains('is-scrolled-start')) {
                            header.classList.remove('scrolled-up');
                            header.classList.remove('stay-top');
                            header.classList.add('is-scrolled');
                        }
                    }
                }
                else {
                    header.classList.remove('is-scrolled-start');
                    header.classList.remove('is-scrolled');
                    if (!header.classList.contains('is-top') && scrollTop > (headerHeight + 40)) {
                        header.classList.add('scrolled-up');
                    }
                }
                lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Mobile
            }, 10);
        }, false);
    };
    /**
     * reset header if user scrolls down more than pager + mainNav height
     *
     */
    PageHeader.prototype.resetHeader = function () {
        var _this = this;
        var isScrolling;
        var mainNavHeight = this.mainNav.clientHeight;
        window.addEventListener('scroll', function () {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            window.clearTimeout(isScrolling);
            isScrolling = setTimeout(function () {
                if (scrollTop > mainNavHeight && _this.header.classList.contains('is-open')) {
                    _this.header.classList.remove('is-open');
                    _this.header.classList.add('stay-top');
                    _this.mainNav.classList.remove('is-open');
                    _this.mainNavToggle.forEach(function (value) {
                        value.classList.remove('is-open');
                    });
                }
            }, 100);
        }, false);
    };
    /**
     * Removing Class is-top, if page is scrolled and not on top.
     * @param header - page-header,
     * @private
     */
    PageHeader.prototype.scrollChangeColor = function (header) {
        window.addEventListener('scroll', function () {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 0) {
                header.classList.remove('is-top');
            }
            else {
                header.classList.add('is-top');
                header.classList.remove('scrolled-up');
            }
        }, false);
    };
    /**
     * Set the color of page-header by first Mask Element respectively the first section Element
     * For Using Method add data-header-color="light-blue" to section Tag
     * @private
     */
    PageHeader.prototype.changeColorOfHeader = function () {
        if (!this.maskFirstElement) {
            return;
        }
        if (this.maskFirstElement.getAttribute('data-header-color')) {
            var color = this.maskFirstElement.getAttribute('data-header-color');
            this.header.classList.add(color);
        }
    };
    /**
     * Set class first-content-element for the first Content Element respectively the first section Element
     * first-content-element margin-top = page-header
     * @private
     */
    PageHeader.prototype.addMarginToFirstContentElement = function () {
        if (!this.maskFirstElement) {
            return;
        }
        this.maskFirstElement.classList.add('first-content-element');
    };
    return PageHeader;
}(abstractComponent_1.default));
exports.default = PageHeader;
